export default __webpack_public_path__ + "static/media/market-place-image.d905da97.png";